import { HTMLAttributes } from 'react';
import Header from '@/website/components/Header';
import { Box } from '@mui/material';

type PageLayoutHeaderProps = HTMLAttributes<HTMLDivElement>;

const PageLayoutHeader = (props: PageLayoutHeaderProps) => {
  return (
    <Box id="jove-website-page-layout-header">
      <Header className="border-none shadow-none" />
    </Box>
  );
};

export default PageLayoutHeader;
